import { useState } from 'react';
import Sidebar from './Sidebar';

export default function AppLayout({ children }) {
  const [menuAberto, setMenuAberto] = useState(false);

  return (
    <div>
      <div className="app-topbar-mobile">
        <button type="button" onClick={() => setMenuAberto(true)} title="Abrir menu">
          <i className="bi bi-list" />
        </button>
        <span>Webhook Datafit</span>
      </div>

      <div className="app-shell">
        {menuAberto && <div className="app-shell__backdrop" onClick={() => setMenuAberto(false)} />}
        <Sidebar abertoMobile={menuAberto} onFecharMobile={() => setMenuAberto(false)} />
        <main className="app-main">{children}</main>
      </div>
    </div>
  );
}
